import {Box, Button, Stack, Typography, useMediaQuery} from "@mui/material";
import {lightTheme} from "../Themes";
import vista_la_laguna2 from "../images/vista_la_laguna_faded_gray4.jpg";
import {globalMaxWidth} from "../GlobalConfigs";
import {TopBanner} from "./TopBanner";
import React from "react";
import ConstructionIcon from '@mui/icons-material/Construction';

export function Portada({with_buttons = true, construction_text = false}) {
    function getButtons(with_buttons) {
        if (with_buttons) {
            return <Stack
                direction={{
                    md: 'row',
                    sm: 'column'
                }}
                alignItems='center'
                spacing={{
                    md: 4,
                    sm: 1,
                    xs: 1
                }}
                sx={{
                    pb: 2
                }}
            >
                <Button variant='contained' href='#presentacion' sx={{
                    width: {lg: '200px', sm: '180px', xs: '160px'},
                    height: {lg: '40px', md: '30px', sm: '20px', xs: '20px'},
                }}>
                    Presentación
                </Button>
                <Button variant='contained' href='#novedades' sx={{
                    width: {lg: '200px', sm: '180px', xs: '160px'},
                    height: {lg: '40px', md: '30px', sm: '20px', xs: '20px'},
                }}
                >
                    Novedades
                </Button>
                <Button variant='contained' href='#fechas' sx={{
                    width: {lg: '200px', sm: '180px', xs: '160px'},
                    height: {lg: '40px', md: '30px', sm: '20px', xs: '20px'},
                }}
                >
                    Fechas Importantes
                </Button>
            </Stack>;
        } else {
            return "";
        }

    }

    function getConstructionText(construction_text) {
        if (construction_text) {
            return (
                <Stack>
                    <Typography variant='h1' sx={{
                        fontSize: {md: '40px', xs: '20px'}
                    }}>
                        Página en construcción
                    </Typography>
                </Stack>
            )
        } else {
            return "";
        }

    }

    let backgroundPosition = {
        xs: 'bottom',
        sm: 'bottom',
        md: 'bottom -25px right 0',
        lg: 'bottom -100px right 0',
        xl: 'bottom -200px right 0',
        x2l: 'bottom -320px right 0',
        x3l: 'bottom -420px right 0',
        x4l: 'bottom -520px right 0',
        x5l: 'bottom -720px right 0'
    };

    if (!with_buttons) {
        backgroundPosition = {
            xs: 'bottom -50px right 0',
            sm: 'bottom -75px right 0',
            md: 'bottom -150px right 0',
            lg: 'bottom -200px right 0',
            xl: 'bottom -250px right 0',
            x2l: 'bottom -320px right 0',
            x3l: 'bottom -420px right 0',
            x4l: 'bottom -520px right 0',
            x5l: 'bottom -720px right 0'
        };
    }

    let backgroundSize = {
        xs: '100%',
        sm: '100%',
        md: '100%',
        lg: '100%',
        xl: '100%',
        x2l: '100%',
        x3l: '100%',
        x4l: '100%',
        x5l: '100%'
    };

    return (
        <Stack alignItems='center' sx={{
            backgroundImage: `url(${vista_la_laguna2})`,
            width: 1,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: backgroundPosition,
            backgroundSize: backgroundSize,
        }}>
            <Stack justifyContent='space-between' alignItems='center' spacing={2} sx={{
                height: 1,
                width: 1,
                maxWidth: globalMaxWidth,
                pt: {
                    md: 4,
                    sm: 2,
                    xs: 1
                },
                pb: {
                    md: 4,
                    sm: 0
                }
            }}>
                <TopBanner/>
                {with_buttons || construction_text ?
                    <Box sx={{
                        height: {xl: '20px', lg: '30px', md: '20px', sm: '0px', xs: '0px'}
                    }}/>
                    :
                    <Box sx={{height: '0px'}}/>
                }
                {getButtons(with_buttons)}
                {getConstructionText(construction_text)}
            </Stack>
        </Stack>
    )
}